"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const getPlainAddress_1 = require("../../space/helpers/getPlainAddress");
const types_1 = require("../../types");
const getConnectedAddresses = _ref => {
  let {
    incomingPeers
  } = _ref;
  const connectedAddresses = [];
  incomingPeers.forEach(incomingPeer => {
    if (incomingPeer.status === types_1.VideoCallStatus.CONNECTED) {
      connectedAddresses.push((0, getPlainAddress_1.default)(incomingPeer.address));
    }
  });
  return connectedAddresses;
};
exports.default = getConnectedAddresses;
//# sourceMappingURL=getConnectedAddresses.js.map